module.exports = __webpack_public_path__ + "static/media/sign-in-with-facebook.09b461d3.png";